export default "__VITE_ASSET__CRCsPJ7r__"